import { Star, BadgeCheck } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";

const REVIEWS = [
  {
    name: "Ugo Pracucci",
    role: "Titolare di ristorante, Lecce",
    avatar: "/avatars/review-ugo.png",
    text: "MIR-IA è stata la svolta per il mio locale. Pagavo un'agenzia 550€ al mese per due post scialbi. Ora so sempre cosa pubblicare, ho foto professionali mie e spendo una cifra ridicola: per un anno intero.",
  },
  {
    name: "Elena Viganò",
    role: "Fisioterapista, libera professionista",
    avatar: "/avatars/review-elena.png",
    text: "Le agenzie che ho sentito cercavano solo di vendermi pacchetti da migliaia di €. MIR-IA invece è davvero dalla parte delle piccole attività e ho fatto la scelta migliore che potesse esserci...consigliata",
  },
  {
    name: "Stefano Moretti",
    role: "Artigiano e interior designer",
    avatar: "/avatars/review-stefano.png",
    text: "Lo shooting fotografico incluso vale da solo tutto l'abbonamento. Finalmente so cosa postare ogni settimana, a un prezzo onesto. Ho lasciato la vecchia agenzia senza pensarci due volte.",
  },
];

const GoogleLogo = () => (
  <svg viewBox="0 0 24 24" className="h-9 w-9 sm:h-11 sm:w-11" aria-label="Google" role="img">
    <path fill="#4285F4" d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.47c-.29 1.48-1.14 2.73-2.4 3.58v3h3.86c2.26-2.09 3.56-5.17 3.56-8.82z" />
    <path fill="#34A853" d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.86-3c-1.08.72-2.45 1.16-4.07 1.16-3.13 0-5.78-2.11-6.73-4.96H1.29v3.09C3.26 21.3 7.31 24 12 24z" />
    <path fill="#FBBC05" d="M5.27 14.29c-.25-.72-.38-1.49-.38-2.29s.14-1.57.38-2.29V6.62H1.29C.47 8.24 0 10.06 0 12s.47 3.76 1.29 5.38l3.98-3.09z" />
    <path fill="#EA4335" d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.95 1.19 15.24 0 12 0 7.31 0 3.26 2.7 1.29 6.62l3.98 3.09C6.22 6.86 8.87 4.75 12 4.75z" />
  </svg>
);

const Stars = () => (
  <div className="relative inline-flex" data-testid="stars-4-8">
    <div className="flex gap-0.5 text-slate-200">
      {[...Array(5)].map((_, i) => (
        <Star key={i} className="h-6 w-6 fill-current" />
      ))}
    </div>
    <div className="absolute inset-0 flex gap-0.5 overflow-hidden text-amber-400" style={{ width: "96%" }}>
      {[...Array(5)].map((_, i) => (
        <Star key={i} className="h-6 w-6 shrink-0 fill-current" />
      ))}
    </div>
  </div>
);

export const Reviews = () => (
  <section id="recensioni" data-testid="reviews-section" className="mx-auto max-w-6xl px-5 py-12">
    <Chapter number="04" label="Dicono di noi" />
    <Reveal>
      <div className="flex flex-col items-center text-center">
        <div className="flex items-center gap-4">
          <GoogleLogo />
          <p data-testid="rating-score" className="font-heading text-6xl font-extrabold tracking-tight text-slate-900 sm:text-7xl">
            4,8
          </p>
        </div>
        <div className="mt-2">
          <Stars />
          <p className="mt-2 text-sm font-medium text-slate-500">
            Valutazione <span className="font-bold text-slate-800">4,8 su 5</span> basata su{" "}
            <span className="font-bold text-slate-800">136 recensioni Google</span>
          </p>
        </div>
      </div>
    </Reveal>
    <div className="mt-8 grid gap-6 md:grid-cols-3">
      {REVIEWS.map((r, i) => (
        <Reveal key={r.name} delay={i * 0.1}>
          <figure
            data-testid={`review-card-${i}`}
            className="flex h-full flex-col rounded-3xl border border-purple-100 bg-white p-6 shadow-sm transition-[transform,box-shadow] duration-300 hover:-translate-y-1.5 hover:shadow-xl hover:shadow-purple-600/10"
          >
            <div className="flex gap-0.5 text-amber-400">
              {[...Array(5)].map((_, s) => (
                <Star key={s} className="h-4 w-4 fill-current" />
              ))}
            </div>
            <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-slate-700">“{r.text}”</blockquote>
            <figcaption className="mt-6 flex items-center gap-3 border-t border-purple-50 pt-4">
              <img
                src={r.avatar}
                alt={`Foto di ${r.name}`}
                data-testid={`review-avatar-${i}`}
                className="h-12 w-12 rounded-full border-2 border-purple-200 object-cover"
                loading="lazy"
              />
              <div>
                <p className="flex items-center gap-1.5 font-heading text-sm font-bold text-slate-900">
                  {r.name}
                  <BadgeCheck className="h-4 w-4 text-purple-600" />
                </p>
                <p className="text-xs text-slate-500">{r.role}</p>
              </div>
            </figcaption>
          </figure>
        </Reveal>
      ))}
    </div>
  </section>
);
